import { EnvironmentProviders, Provider } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import * as DevicesListingPageEffects from '../../services/devices-listing-page.effects';
import { devicesMapConfigProvider } from '../../services/devices-map-config.service';
import { DcuListingFiltersSourceService } from './dcu-listing-filters-source.service';
import { DcuListingModelService } from './dcu-listing-model.service';

export const provideDcuListing = (): (Provider | EnvironmentProviders)[] => [
  DcuListingFiltersSourceService,
  { provide: LISTING_MODEL, useClass: DcuListingModelService },
  ListingPageService,
  QueryParamsHandlerService,
  provideEffects(DevicesListingPageEffects),
  devicesMapConfigProvider
];
